import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/pages/Dashboard'
import Tools from '@/components/pages/tools'
import Tekenaars from '@/components/pages/Tekenaars'
import Kaart from '@/components/pages/kaart'
import Opdrachten from '@/components/pages/Opdrachten'
import Blog from '@/components/pages/Blog'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/tools',
      name: 'Tools',
      component: Tools,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tekenaars',
      name: 'Tekenaars',
      component: Tekenaars,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/kaart',
      name: 'kaart',
      component: Kaart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/opdrachten',
      name: 'Opdrachten',
      component: Opdrachten,
      meta: {
        requiresAuth: true
      }
    }
  ]
})
